window.addEventListener('load', () => {
  const compare_pop_open = document.querySelector('#main-nav li.compare_us');
  const compare_pop_close = document.querySelector('.compare_us_popup .close_btn');
  const compare_popup_overlay = document.querySelector(".popup_overlay");
  
  compare_pop_open.addEventListener('click', () => {
    const el = document.querySelector('body');    
    el.classList.add('active_pop');  
  })
  
  compare_pop_close.addEventListener('click', () => {
    const el = document.querySelector('body');    
    el.classList.remove('active_pop');  
  })

  // Detect all clicks on the document
  compare_popup_overlay.addEventListener("click", function(event) {  
  	// If user clicks outside the element, hide it!
    const el = document.querySelector('body');   
  	el.classList.remove('active_pop');
  });
})